
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fotobox-vergleich",
      function () {
        return require("private-next-pages/fotobox-vergleich.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fotobox-vergleich"])
      });
    }
  